export default "__VITE_ASSET__CzEChKL6__"